module.exports = __webpack_public_path__ + "img/person.754aeac7.svg";